module.exports = __webpack_public_path__ + "img/item-set.e10f229f.png";